import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";

// import ProductEight from '../list/product-';
import ProductEight from "../product-two-mobile";
import ProductTwo from "../product-two";
import QuickView from "../common/quickview";

import { addToCart } from "../../../../actions";

import LoadingOverlay, { SpecialLoadingOverlay } from "../../loading-overlay";

let width = window.innerWidth;

function ProductListByCategory(props) {
  const {
    variants,
    variantsCount,
    type,
    isLoading,
    fetchNextPage,
    isFetching,
    isSlugChanged,
    hasNextPage,
  } = props;

  const classList = {
    boxed: "col-6 col-md-4 col-lg-4 col-xl-3",
    fullwidth: "col-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2",
  };

  function loadMore() {
    fetchNextPage();
  }

  useEffect(() => {
    const scrollPosition = JSON.parse(sessionStorage.getItem("scrollPosition"));
    if (scrollPosition) {
      window.scrollTo(...scrollPosition);
      sessionStorage.removeItem("scrollPosition");
    }
    return () => {
      sessionStorage.setItem(
        "scrollPosition",
        JSON.stringify([window.pageXOffset, window.pageYOffset])
      );
    };
  }, []);

  if (isLoading || isSlugChanged) {
    return <SpecialLoadingOverlay />;
  }
  return !isLoading ? (
    <>
      <div className="toolbox">
        <div className="toolbox-center">
          <div className="toolbox-info">
            Affichage de{" "}
            <span>
              {variants.length} sur {variantsCount}
            </span>{" "}
            Produits
          </div>
        </div>
      </div>

      <div className="products mb-3">
        <div className="row">
          {variants.map((item, index) =>
            width > 900 ? (
              <div className={classList[type]} key={item.id}>
                <ProductTwo product={item} onAddToCart={addToCart} />
              </div>
            ) : (
              <div className="col-12">
                <ProductEight product={item} onAddToCart={addToCart} />
              </div>
            )
          )}
        </div>

        <QuickView />
      </div>

      {hasNextPage && (
        <div className="load-more-container text-center">
          <button
            className="btn btn-outline-darker btn-load-more"
            onClick={loadMore}
          >
            <span>Plus de produits </span>
            {isFetching ? (
              <i className="icon-refresh load-more-rotating"></i>
            ) : (
              <i className="icon-refresh"></i>
            )}
          </button>
        </div>
      )}
    </>
  ) : (
    <LoadingOverlay />
  );
}

export default ProductListByCategory;
